const pollFn = <T>(
  apiCall: () => Promise<T>,
  validation: (_data: T) => boolean,
  interval: number,
  maxAttempts = 10,
  currentAttempt = 0,
): Promise<T> =>
  new Promise((resolve, reject) => {
    apiCall()
      .then((res) => {
        if (!validation(res) && currentAttempt < maxAttempts - 1) {
          setTimeout(() => {
            pollFn(apiCall, validation, interval, maxAttempts, currentAttempt + 1)
              .then(resolve)
              .catch((err: unknown) => {
                // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
                reject(err)
              })
          }, interval)
        } else if (validation(res)) {
          resolve(res)
        } else {
          reject(new Error('Max attempts reached without validation passing'))
        }
      })
      .catch((err: unknown) => {
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        reject(err)
      })
  })

export const poll = async <T>(
  apiCall: () => Promise<T>,
  validation: (_data: T) => boolean,
  interval: number,
  maxAttempts = 10,
): Promise<T> => {
  if (maxAttempts <= 0) {
    throw new Error('Max attempts cannot be less than or equal to 0')
  }
  if (maxAttempts * interval > 60 * 1000) {
    throw new Error('Max call duration cannot be greater than 60 seconds')
  }
  if (interval < 100) {
    throw new Error('Interval cannot be less than 100 milliseconds')
  }
  const res = await pollFn<T>(apiCall, validation, interval, maxAttempts)
  return res
}
